export const fullDateFormatter = new Intl.DateTimeFormat([], {
    dateStyle: 'full',
} as any)
